import { NgModule } from '@angular/core';
import { LIB_CommonModule } from 'pbc.angular';
import { ZeitUnterartsFilterComponent } from '.';
import { ZeitUnterartsServiceModule } from '..';

@NgModule({
  imports: [
    LIB_CommonModule,
    ZeitUnterartsServiceModule
  ],
  declarations: [ZeitUnterartsFilterComponent],
  exports: [ZeitUnterartsFilterComponent],

})
export class ZeitUnterartsFilterComponentModule { }
